import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue"

import i18n from "@/i18n"
import { useSyncListStore } from "@/modules/sync/store/useSyncListStore"
import { useSyncStore } from "@/modules/sync/store/useSyncStore"

// Helper Types/Variables
type Props = {
  isOpened: boolean
  syncUuid: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DeleteSyncModal',
  props: {
    isOpened: { type: Boolean },
    syncUuid: null
  },
  emits: ["close", "delete"],
  setup(__props: any, { emit }) {

const props = __props as {
  isOpened: boolean
  syncUuid: string
};



// End Helper Types/Variables

// Store & Route
const syncStore = useSyncStore()
const syncListStore = useSyncListStore()
// End Store & Route

// State
const deleteConfirmationKey = ref(i18n.t("synchronization.delete_key"))
const deleteConfirmationValue = ref("")
const deleteRequest = ref(false)
// End State

// Computed
const deleteConfirmationValueIsValid = computed(() => {
  return deleteConfirmationValue.value.trim() === deleteConfirmationKey.value
})
// End Computed

// Methods
const handleDeleteSync = () => {
  deleteRequest.value = true
  syncStore
    .deleteSynchronization(props.syncUuid)
    .then(() => {
      syncListStore.getSynchronizations()
      emit("close")
      emit("delete")
    })
    .catch((e: any) => {
      console.error(e)
    })
    .finally(() => {
      deleteRequest.value = false
    })
}
// End Methods

return { __sfc: true,props, emit, syncStore, syncListStore, deleteConfirmationKey, deleteConfirmationValue, deleteRequest, deleteConfirmationValueIsValid, handleDeleteSync }
}

})